module.exports = __webpack_public_path__ + "media/images/emoticons/thunder-cbba4405913918dc6252d9edac9f28f2.gif";